import React from 'react';
import {findDOMNode} from "react-dom"
import NavigationMenuItem from "../../../menu-items/menu-item";
import NavigationSection from "../../../../../core/model2/navigation/navigation-section";
import PersonalView from "../../../../../core/model2/view/personal-view/personal-view";
import {PersonalViewLocation} from "../../../../../core/model2/view/personal-view/@types";
import {BUS_APP_LAUNCH} from "../../../../../core/gd/app-manager/@event"

type State = {
    selected        : boolean,
    useHint         : boolean
}

type Props = {
    className?          : string

    navigationSection   : NavigationSection
    view                : PersonalView,
    style?              : style
    dndPreview?         : any
    dndIsDragged?       : boolean
    hidePopover?        : callback // used when in popover menu (personal views more menu)
    iconMoreClass?      : string    // icon more class optional
}

export default class NavigationMenuItemPersonalView extends React.Component<Props,State> {

    public debouncedCheckHint       : any
    public view                 : PersonalView

    constructor(props:Props) {
        super(props)


        this.view = props.view

        this.state = {
            selected    : this.view.isOpen,
            useHint     : false
        }

        this.debouncedCheckHint = _.debounce(this._checkHintUsage, 300)
    }

    componentDidMount() {
        gd.bus.subscribe(BUS_APP_LAUNCH, this, this.onLaunchApp)

        this.debouncedCheckHint()
    }

    componentDidUpdate() {
        this.debouncedCheckHint()
    }

    componentWillUnmount = () => {
        this.debouncedCheckHint.cancel()

        gd.bus.unsubscribe(this)
    };

    onClick = () => {
        // this.view.url
        this.view.open()

        if (this.props.navigationSection) {
            this.props.navigationSection.defaultAppUrl = this.view.url
        }

        this.props.hidePopover?.()   // same as func && func() syntaxis
    }

    _checkHintUsage = () => {
        const useHint = gd.utils.getTextExceedsNodeWidth(this.view.name, findDOMNode(this), 56, 14)

        if (this.state.useHint !== useHint) {
            this.setState({
                useHint: useHint
            })
        }
    }

    onLaunchApp = (params:any) => {
        // just in case
        if (!this.view) return

        if (this.state.selected) {
            !this.view.isOpen && this.setState({selected: false})
        } else {
            this.view.isOpen && this.setState({selected: true})
        }
    }


    render () {
        // patch to prevent errors
        if (!this.view) return false

        const classes = Classes('viewId-'+this.view.id /*required for scroll to node*/, this.props.className)

        return (
            <NavigationMenuItem className       = {classes}
                                name            = {this.view.name}
                                selected        = {this.state.selected}
                                icon            = {Classes('icon', this.view.icon)}
                                style           = {this.props.style}
                                dndPreview      = {this.props.dndPreview}
                                dndIsDragged    = {this.props.dndIsDragged}
                                onClick         = {this.onClick}
                                moreMenuOptions = {this.props.view.menuMoreOptions()}
                                iconMoreClass   = {this.props.iconMoreClass}
                                isShared        = {false}
                                {...this.props}/>
        )

    }
}
